module.exports = __webpack_public_path__ + "media/images/sprites/dark-54908f661c4ff23882eaac8ea90cc5c5.png";